import React from "react";

const USPCard = ({ image, title, description }) => {
  return (
    <div className="col-lg-4 col-md-6 mb-4">
      <div className="usp-card wow animate__animated animate__fadeInUp">
        <img
          src={image}
          alt={title}
          width="70"
          height="70"
          loading="lazy"
        />

        <h3>{title}</h3>

        <p>{description}</p>
      </div>
    </div>
  );
};

export default React.memo(USPCard);